import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatusIcon(_ref) {
  var status = _ref.status,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  switch (status) {
    case 'passed':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        role: "img",
        "aria-label": "Passed",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: 8,
          cy: 8,
          r: 8,
          fill: "#176F2C"
        }), /*#__PURE__*/_jsx("path", {
          d: "M4.5 8L6.57264 10.4319C6.60359 10.4683 6.65925 10.4695 6.69189 10.4347L11.3182 5.5",
          stroke: "white",
          strokeWidth: 1.25,
          strokeLinecap: "round"
        })]
      });
    case 'failed':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        role: "img",
        "aria-label": "Failed",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: 8,
          cy: 8,
          r: 8,
          fill: "#CF222E"
        }), /*#__PURE__*/_jsx("path", {
          d: "M6 10L10 6M6 6L10 10",
          stroke: "white",
          strokeWidth: 1.25,
          strokeLinecap: "round"
        })]
      });
    case 'broken':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        role: "img",
        "aria-label": "Broken",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: 8,
          cy: 8,
          r: 8,
          fill: "#BC4C00"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.25 10.9C7.25 10.6239 7.47386 10.4 7.75 10.4H8.25C8.52614 10.4 8.75 10.6239 8.75 10.9V11.5C8.75 11.7761 8.52614 12 8.25 12H7.75C7.47386 12 7.25 11.7761 7.25 11.5V10.9ZM7.25 4.5C7.25 4.22386 7.47386 4 7.75 4H8.25C8.52614 4 8.75 4.22386 8.75 4.5V8.3C8.75 8.57614 8.52614 8.8 8.25 8.8H7.75C7.47386 8.8 7.25 8.57614 7.25 8.3V4.5Z",
          fill: "white"
        })]
      });
    case 'skipped':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        role: "img",
        "aria-label": "Skipped",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: 8,
          cy: 8,
          r: 8,
          fill: "#59636e"
        }), /*#__PURE__*/_jsx("path", {
          d: "M10.2667 5.6V9.93333M9.10667 8.05467L6.10133 9.80767C6.05068 9.83717 5.99311 9.85285 5.93446 9.85312C5.87582 9.85339 5.81815 9.83801 5.76729 9.8088C5.71643 9.77958 5.67418 9.73741 5.64481 9.68671C5.61544 9.636 5.59998 9.57831 5.6 9.51967V6.01367C5.59998 5.95502 5.61544 5.8974 5.64481 5.84663C5.67418 5.79587 5.71643 5.75375 5.76729 5.72454C5.81815 5.69532 5.87582 5.68004 5.93446 5.68024C5.99311 5.68044 6.05068 5.6961 6.10133 5.72567L9.10633 7.479C9.15664 7.50837 9.19832 7.55039 9.22728 7.6009C9.25625 7.65139 9.27152 7.70861 9.27152 7.76683C9.27152 7.82506 9.25625 7.88228 9.22728 7.93277C9.19832 7.98327 9.15696 8.02529 9.10667 8.05467Z",
          stroke: "white",
          strokeWidth: 1,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case 'unknown':
    default:
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        role: "img",
        "aria-label": "Unknown status",
        children: /*#__PURE__*/_jsx("circle", {
          cx: 8,
          cy: 8,
          r: 7,
          stroke: "#D0D7DE",
          strokeWidth: 2
        })
      });
  }
}